var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PowerMini") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.53 2.94997C10.05 2.66997 9.44 2.82997 9.16 3.30997C8.88 3.78997 9.04 4.39997 9.52 4.67997C11.05 5.56997 12 7.22997 12 8.99997C12 11.76 9.76 14 7 14C4.24 14 2 11.76 2 8.99997C2 7.22997 2.95 5.57997 4.48 4.67997C4.96 4.39997 5.12 3.78997 4.84 3.30997C4.56 2.82997 3.95 2.66997 3.47 2.94997C1.33 4.20997 0 6.52997 0 8.99997C0 12.86 3.14 16 7 16C10.86 16 14 12.86 14 8.99997C14 6.51997 12.67 4.19997 10.53 2.94997Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7C7.55 7 8 6.55 8 6V1C8 0.45 7.55 0 7 0C6.45 0 6 0.45 6 1V6C6 6.55 6.45 7 7 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerMini);
export default __webpack_public_path__ + "static/media/PowerMini.788f39026013388b62da0090fe1bde71.svg";
export { ForwardRef as ReactComponent };